import cx from 'classnames'
import { CSSProperties, ChangeEvent, ReactNode } from 'react'
import s from './style.module.scss'

interface ITextProps {
  children: ReactNode
  as?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'p' | 'span' | 'div' | 'li' | 'b' | 'i' | 'small' | 'strong'
  className?: string
  style?: CSSProperties
  size?: 'xxxl' | 'xxl' | 'xl' | 'lg' | 'md' | 'sm' | 'xs' | 'xxs'
  color?:
    | string
    | 'gray-dark'
    | 'gray'
    | 'gray-light'
    | 'white'
    | 'black-light'
    | 'red'
    | 'blue-dark'
    | 'green'
    | 'input-border'
  align?: 'start' | 'end' | 'center' | 'justify'
  weight?: 'bold' | 'semibold' | 'medium' | 'regular' | 'light'
  overflow?: 'fade' | 'ellipsis'
  transform?: 'lowercase' | 'uppercase' | 'capitalize'
  decoration?: 'underline' | 'line-through'
  whiteSpace?: 'pre-line' | 'nowrap'
  family?: 'primary' | 'secondary'
  cursor?: 'pointer'
  required?: boolean
  disable?: boolean
  onClick?: (e: ChangeEvent<any>) => void
}

function Text({
  children,
  as: ElementType = 'span',
  className,
  style,
  size,
  color = 'primary',
  align,
  weight,
  overflow,
  transform,
  decoration,
  whiteSpace,
  family,
  cursor,
  required,
  disable,
  onClick,
  ...props
}: ITextProps) {
  const classList = cx(
    s.text,
    {
      [s[`text-${size}`]]: size,
      [s[`color-${color}`]]: color,
      [s[`text-${align}`]]: align,
      [s[`text-${weight}`]]: weight,
      [s[`text-overflow-${overflow}`]]: overflow,
      [s[`text-transform-${transform}`]]: transform,
      [s[`text-decoration-${decoration}`]]: decoration,
      [s[`white-space-${whiteSpace}`]]: whiteSpace,
      [s[`font-family-${family}`]]: family,
      [s[`cursor-${cursor}`]]: cursor,
      [s.required]: required,
      [s.disable]: disable
    },
    className
  )

  return (
    <ElementType className={classList} style={style} onClick={onClick} {...props}>
      {children}
    </ElementType>
  )
}

export default Text
